import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MapIcon from '@mui/icons-material/Map';
import { Box, Container, Divider, Fab, Fade, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';
import "../../styles/events.css"; // Import CSS
import { theme } from '../../styles/theme';
import { cardGridSize } from '../../utils/constants';
import { AppBarPadding, BottomPadding } from '../../utils/helperUtils';
import SearchEventsVendorCardComponent from '../Events/components/SearchEventsVendorCardComponent';
import SearchComponent from '../Events/components/SearchComponent';
import ExploreMapView from '../components/ExploreMapView';
// import ExploreMapView from '../components/ExploreMapView';
// import SearchComponent from './components/SearchComponent';
// import SearchEventsVendorCardComponent from './components/SearchEventsVendorCardComponent';

function ExploreVendorView() {
    const [searchQuery, setSearchQuery] = useState("");

    const [listView, setListView] = useState(true)

    const FloatingActionButton = () => {
        const handleClick = (e) => {
            e?.preventDefault();
            setListView((listView) => !listView)
            // navigate("/_/events/organizer/create");

        };

        return (
            <Tooltip title="Create New Event" arrow>
                <Fab
                    variant="extended"
                    // color={theme.colors.events.secondary}
                    onClick={(e) => handleClick(e)}
                    sx={{
                        position: "fixed",
                        bottom: 20,
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: theme.colors.events.secondary,
                        color: theme.colors.events.primaryDark,
                        fontWeight: "bold",
                        "&:hover": {
                            backgroundColor: theme.colors.events.primary,
                        },
                    }}
                >
                    {listView ? <MapIcon sx={{ mr: 1 }} /> : <FormatListBulletedIcon sx={{ mr: 1 }} />}
                    {listView ? "Map" : "List"} View
                </Fab>
            </Tooltip>
        );
    };

    return (
        <Box bgcolor={theme.colors.events.primary} >
            <Container maxWidth="xl" className="events-box-container">
                <AppBarPadding />
                <Grid container justifyContent={'center'}>
                    <Grid size={{ md: 12, lg: 6, xs: 12 }}>
                        <Typography fontSize={{ xs: 25, md: 30 }} color={theme.colors.events.secondary}>
                            <Box sx={{ fontWeight: 'bold', mb: 1 }}>
                                Search Nearby Events 🔍
                            </Box>
                        </Typography>
                        <Divider sx={{ borderBottomWidth: 2, bgcolor: theme.colors.events.secondary }} />
                        {/* 🔍 Search Bar */}
                        <SearchComponent
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                            onSearchClick={() => console.log("Searching for:", searchQuery)}
                        />
                        <Box
                            sx={{
                                position: 'relative',
                                height: 400, // set a fixed height to prevent layout shift
                                mt: 2,
                            }}
                        >
                            {/* List View */}
                            <Fade in={listView} timeout={400} unmountOnExit>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid size={cardGridSize}>
                                            <SearchEventsVendorCardComponent />
                                        </Grid>
                                        <Grid size={cardGridSize}>
                                            <SearchEventsVendorCardComponent />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Fade>

                            {/* Map View */}
                            <Fade in={!listView} timeout={400} unmountOnExit>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <ExploreMapView />
                                </Box>
                            </Fade>
                        </Box>
                    </Grid>
                </Grid>
                <FloatingActionButton />
                <BottomPadding />
            </Container>
        </Box>
    )
}

export default ExploreVendorView